import { Directive } from '@angular/core';

@Directive({
  selector: '[appScrollContainer]',
  host: {
    style: 'overflow-x: auto; overflow-y: auto; overscroll-behavior: contain;',
    tabindex: '0',
  },
})
export class ScrollContainerDirective {}
